var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.suggestionsList),function(suggestion,idx){return _c('v-row',{key:idx,attrs:{"no-gutters":""}},[_c('the-suggestion',{attrs:{"dataSourceName":_vm.dataSourceName,"featureId":_vm.featureId,"layer-id":_vm.layerId,"suggestion":suggestion}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }